import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetReportSpecificFieldsQuery } from "../../../api/network/reportApiServices";
import { TModalsState } from "../../../api/store/commonSlice";
import { DASHBOARD_WIDGET_TYPE } from "../../../api/types/Overview";
import svgIcons from "../../../assets/svg/svgIcons";
import AdminTable from "../../../components/adminTable";
import { APP_CONFIG } from "../../../constants/constants";
import useConversion from "../../../hooks/conversion";
import { AGGREGATE_FUNCTION } from "../../reports/components/popupReportColumnAggregation";
import { REPORT_FIELD_OUTPUT_TYPES } from "../../reports/constants";
import ChartWrapper from "../components/chartWrapper";
import ModalSwitchChartType from "../components/modalSwitchChartType";
import { IWidgetProps } from "../components/overviewDragDropColumnItem";
import WidgetChartAreaGenerator from "../components/widgetChartAreaGenerator";
import WidgetFilterSelector from "../components/widgetFilterSelector";
import { useOverviewContext } from "../context/overview.context";
import { useGroupsAndAssetsUtils } from "../hooks/overviewScreenUtils";
import ModalWidgetDetails from "../modalWidgetDetails";
import { EWidgetChartTypes } from "../types/overview.types";
import { verticalLabelFormatter } from "../utils/chart";

const tableMinHeightClass = "min-h-[100px]";
const tableMaxHeightClass = "max-h-[224px]";

const defaultChartType = EWidgetChartTypes.VERTICAL_BAR_GRAPH;

interface IWidgetMaintenanceDue extends IWidgetProps {
  showDetails: boolean;
  setShowDetails: (value: boolean) => void;
}

const WidgetMaintenanceDue: FC<IWidgetMaintenanceDue> = ({
  widgetType,
  showDetails,
  setShowDetails,
}) => {
  const { t: tOverview } = useTranslation("translation", {
    keyPrefix: "overviewScreen",
  });
  const { t } = useTranslation("translation", {
    keyPrefix: `overviewScreen.widgets.enum_${widgetType}`,
  });

  const { convertToUnit, getUnitByOutputType } = useConversion();

  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );
  const [selectedChartType, setSelectedChartType] = useState(defaultChartType);

  const {
    allTimeFilters,
    timeFilter,
    allGroupsSelected,
    selectedGroups,
    selectedDataType,
    setSelectedDataType,
    allAssetsSelected,
    selectedAssets,
    setAllAssetsSelected,
    setSelectedAssets,
  } = useOverviewContext();

  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");

  const reportId =
    widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES
      ? 71
      : widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS
        ? 72
        : 73; // DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD

  const graphXAxisDataKey = // 'Asset ID';
    widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES
      ? "443"
      : widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS
        ? "448"
        : "453"; // DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD
  const graphYAxisDataKey = // 'Miles left to Service';
    widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES
      ? "447"
      : widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS
        ? "452"
        : "457"; // DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD

  const ordering = `${sortOrder === "asc" ? "" : "-"}${graphYAxisDataKey}`;

  const widgetPayload =
    widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES
      ? {
          // id: '71',
          fields: "443,444,447".split(","),
        }
      : widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS
        ? {
            // id: '72',
            // fields: '443,444,447,452'.split(','), // TODO: check these
          }
        : {
            // DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD
            // id: '73',
            // fields: '443,444,447,457'.split(','),
          };

  const {
    data: dataSpecificReport,
    isFetching: isFetchingSpecificReport,
    isUninitialized: isUninitializedSpecificReport,
  } = useGetReportSpecificFieldsQuery(
    {
      // type: REPORT_TYPES.CUSTOM,
      report_id: reportId,
    },
    { refetchOnMountOrArgChange: true }
  );

  // const { data: dataReport, isFetching } = useRunReportQuery(
  //   {
  //     id: reportId.toString(),
  //     ...(widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES
  //       ? {
  //           // id: '71',
  //           fields: "443,444,447".split(","),
  //         }
  //       : widgetType === DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS
  //         ? {
  //             // id: '72',
  //             // fields: '443,444,447,452'.split(','), // TODO: check these
  //           }
  //         : {
  //             // DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD
  //             // id: '73',
  //             // fields: '443,444,447,457'.split(','),
  //           }),
  //     ordering: `${sortOrder === "asc" ? "" : "-"}${graphYAxisDataKey}`,
  //     page: 1,
  //     page_size: 10,

  //     // filters
  //     device_groups:
  //       allGroupsSelected === false && !!selectedGroups
  //         ? selectedGroups
  //         : undefined,
  //     start_time: !!allTimeFilters.find((filter) => filter.slug === timeFilter)
  //       ?.timeRange[0]
  //       ? jsTimeToDBTime(
  //           allTimeFilters
  //             .find((filter) => filter.slug === timeFilter)
  //             ?.timeRange[0]?.getTime() ?? 0
  //         )
  //       : undefined,
  //     end_time: !!allTimeFilters.find((filter) => filter.slug === timeFilter)
  //       ?.timeRange[1]
  //       ? jsTimeToDBTime(
  //           allTimeFilters
  //             .find((filter) => filter.slug === timeFilter)
  //             ?.timeRange[1]?.getTime() ?? 0
  //         )
  //       : undefined,
  //     ds_time_range: allTimeFilters.find((filter) => filter.slug === timeFilter)
  //       ?.value,
  //   },
  //   {
  //     skip: isUninitializedSpecificReport || isFetchingSpecificReport,
  //     refetchOnMountOrArgChange: true,
  //   }
  // );

  const {
    reportData: dataReport,
    isFetching,
    isError,
    reportError,
  } = useGroupsAndAssetsUtils(
    selectedDataType,
    reportId,
    selectedAssets,
    1,
    10,
    ordering,
    widgetPayload
  );

  const MemoizedWidgetFilterSelector = // useCallback(() => {
    ({ limitWidth = true }: { limitWidth?: boolean }) => {
      return (
        <div className="mb-4 flex justify-between">
          <WidgetFilterSelector
            limitWidth={limitWidth}
            selectedFilterLabel={t(`filter_label_sorting_${sortOrder}`)}
            filters={[
              { label: t("filter_label_sorting_desc"), value: "desc" },
              { label: t("filter_label_sorting_asc"), value: "asc" },
            ]}
            setFilter={(newValue) => setSortOrder(newValue as "asc" | "desc")}
          />
        </div>
      );
    };
  //, [sortOrder])

  const DetailsTable: FC<{
    heightLimitClass: string;
    tableColumns: string[];
    useSortableColumns?: boolean;
  }> = ({ heightLimitClass, tableColumns, useSortableColumns = false }) => {
    return (
      <AdminTable
        customWrapperClass={`overflow-auto relative w-full`}
        columns={tableColumns.map((key: string) => {
          const reportField = dataSpecificReport?.report_fields?.find(
            (field) => field.field.id === parseInt(key)
          );
          const unitForOutputType = getUnitByOutputType(
            reportField?.output_type
          );
          return (
            (reportField?.field?.name || "-") +
            (reportField?.aggregate_function !== AGGREGATE_FUNCTION.COUNT && // don't show unit for COUNT
            !!unitForOutputType
              ? ` (${unitForOutputType})`
              : "") +
            (APP_CONFIG.DEBUG.DISPLAY_VERBOSE ? " (" + key + ")" : "")
          );
        })}
        compact={!useSortableColumns}
        data={
          [...(dataReport?.results || [])]
            ?.sort((a, b) => a[graphYAxisDataKey] - b[graphYAxisDataKey])
            ?.map((resultItem: any) => {
              {
                return {
                  navLink: "",
                  // Object.values(resultItem)
                  cellData: tableColumns.map((column) => {
                    const fieldData = dataSpecificReport?.report_fields?.find(
                      (field) => field.field.id === parseInt(column)
                    );
                    return typeof resultItem[column] === "number" &&
                      !Number.isInteger(resultItem[column])
                      ? convertToUnit(
                          fieldData?.output_type ||
                            REPORT_FIELD_OUTPUT_TYPES.TEXT,
                          resultItem[column],
                          false
                        )?.finalData
                      : resultItem[column];
                  }),
                  cellDataMeta: tableColumns.map((column) => {
                    const fieldData = dataSpecificReport?.report_fields?.find(
                      (field) => field.field.id === parseInt(column)
                    );
                    return typeof resultItem[column] === "number" &&
                      !Number.isInteger(resultItem[column]) &&
                      fieldData?.output_type !== REPORT_FIELD_OUTPUT_TYPES.TEXT
                      ? resultItem[column]
                      : "";
                  }),
                };
              }
            }) || []
        }
        heightLimitClass={heightLimitClass}
        isLoading={false}
        rightAlignLastColumn={!useSortableColumns}
        useSortableColumns={useSortableColumns}
      />
    );
  };

  const computedChartData = [...(dataReport?.results || [])]
    ?.sort((a, b) => b[graphYAxisDataKey] - a[graphYAxisDataKey])
    ?.map((dataSet) => {
      const fieldData = dataSpecificReport?.report_fields?.find(
        (field) => field.field.id === parseInt(graphYAxisDataKey)
      );
      const yAxisDataValue =
        typeof dataSet[graphYAxisDataKey] === "number"
          ? parseFloat(
              convertToUnit(
                fieldData?.output_type || REPORT_FIELD_OUTPUT_TYPES.TEXT,
                dataSet[graphYAxisDataKey],
                false
              )?.finalData
            )
          : dataSet[graphYAxisDataKey];
      return {
        ...dataSet,
        [graphYAxisDataKey]: yAxisDataValue,
      };
    });

  return (
    <div className="mt-2">
      {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
        <pre className="absolute text-[8px] text-field-error-dark -mt-2">
          reportId: {reportId}
        </pre>
      )}

      {/* Filter */}
      <MemoizedWidgetFilterSelector />

      {(!!dataReport && dataReport?.results?.length > 0) || isFetching ? (
        <>
          {isFetching ? (
            <ChartWrapper heightClass="pt-[45%]">
              <img
                src={svgIcons.LoadingAnimation}
                alt="laoding"
                className="absolute size-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              />
            </ChartWrapper>
          ) : (
            <>
              <WidgetChartAreaGenerator
                barChartMargin={
                  selectedChartType === EWidgetChartTypes.HORIZONTAL_BAR_GRAPH
                    ? { top: 0, right: 10, bottom: 0, left: -20 }
                    : { top: 0, right: 10, bottom: 20, left: -30 }
                }
                cellItemsForSectionColor={computedChartData}
                chartType={selectedChartType}
                chartWrapperHeightClass={
                  selectedChartType === EWidgetChartTypes.HORIZONTAL_BAR_GRAPH
                    ? "pt-[100%]"
                    : "pt-[45%]"
                }
                computedChartData={computedChartData}
                graphXAxisDataKey={graphXAxisDataKey}
                graphYAxisDataKey={graphYAxisDataKey}
                legendValueFormatter={(value: any) =>
                  value.toFixed(2).replace(".00", "")
                }
                legendVerticalAlignClass="justify-start"
                showYZeroReferenceLine={true}
                t={t}
                usePNBarColors={true}
                widgetType={widgetType}
                xAxisAngle={-45}
                xAxisTickLabelWidth={40}
                xAxisTickUsesTranslation={false}
                yAxisTickFormatter={(value) =>
                  value === 0 ? "0" : verticalLabelFormatter(value)
                }
              />
              {/* <SwitchChartButton onClick={() => {
                  dispatch(setModalsData({ ...modalsState, switchChartTypeForWidget: widgetType, showSwitchChartType: true }))
                }} />
                <ResponsiveContainer className={'absolute top-0 left-0 w-full h-full'}>
                  <BarChart
                    width={500}
                    height={500 * 0.45}
                    data={
                      [...dataReport?.results || []]
                        ?.sort((a, b) => a[graphYAxisDataKey] - b[graphYAxisDataKey])
                    }
                    margin={{
                      top: 0,
                      right: 10,
                      bottom: 20,
                      left: -30,
                    }}
                  // barCategoryGap={10}
                  >
                    <defs>
                      <linearGradient id="colorPositive" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor={chartColors.positive.light} stopOpacity={1} />
                        <stop offset="100%" stopColor={chartColors.positive.dark} stopOpacity={1} />
                      </linearGradient>
                      <linearGradient id="colorNegative" x1="0" y1="1" x2="0" y2="0">
                        <stop offset="0%" stopColor={chartColors.negative.light} stopOpacity={1} />
                        <stop offset="100%" stopColor={chartColors.negative.dark} stopOpacity={1} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis
                      dataKey={graphXAxisDataKey} style={{ fontSize: '8px' }}
                      // tickFormatter={(value) => value.toString().substring(0, 10)}
                      angle={-45}
                      tick={(props) => <ChartsCustomXAxisTick labelWidth={40} {...props} />}
                    />
                    <YAxis
                      dataKey={graphYAxisDataKey} style={{ fontSize: '8px' }}
                      tickFormatter={(value) => value === 0 ? '0' : verticalLabelFormatter(value)}
                    />
                    {
                      // <Tooltip />
                      // <Legend />
                    }
                    <ReferenceLine y={0} stroke="#000" />
                    <Bar
                      dataKey={graphYAxisDataKey}
                      fill="#8884d8"
                    // barSize={25}
                    >
                      {[...dataReport?.results || []]
                        ?.sort((a, b) => a[graphYAxisDataKey] - b[graphYAxisDataKey])
                        ?.map((resultItem, index) => (
                          <Cell
                            cursor="pointer"
                            fill={`url(#color${resultItem[graphYAxisDataKey] > 0 ? 'Positive' : 'Negative'})`}
                            key={`cell-${index}`}
                            radius={5}
                          />
                        ))}
                    </Bar>
                    {
                    // <Bar dataKey="uv" fill="#82ca9d" />
                    }
                  </BarChart>
                </ResponsiveContainer> */}
            </>
          )}

          {/* Table */}
          {isFetching ? (
            <div
              className={`${tableMinHeightClass} ${tableMaxHeightClass} flex justify-center items-center relative`}
            >
              <img
                src={svgIcons.LoadingAnimation}
                alt="laoding"
                className="absolute size-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              />
            </div>
          ) : (
            <>
              <DetailsTable
                heightLimitClass={`${tableMinHeightClass} ${tableMaxHeightClass}`}
                tableColumns={[graphXAxisDataKey, graphYAxisDataKey]}
              />
              <ModalWidgetDetails
                widgetType={widgetType}
                reportId={reportId}
                visible={showDetails}
                onHide={() => setShowDetails(false)}
              >
                <MemoizedWidgetFilterSelector limitWidth={false} />
                <DetailsTable
                  heightLimitClass={`${tableMinHeightClass} max-h-[calc(100vh-220px)]`}
                  // tableColumns={!!dataReport?.results?.[0] ? Object.keys(dataReport?.results?.[0]) : []}
                  tableColumns={
                    dataSpecificReport?.report_fields?.map((field) =>
                      field.field.id.toString()
                    ) || []
                  }
                  useSortableColumns={true}
                />
              </ModalWidgetDetails>
            </>
          )}
        </>
      ) : (
        <p className="p-6 text-center text-sm text-heading-gray888">
          {tOverview("no_widget_data")}
        </p>
      )}
      {modalsState.showSwitchChartType &&
        modalsState.switchChartTypeForWidget === widgetType && (
          <ModalSwitchChartType
            selectedChartType={selectedChartType}
            onChartTypeChange={(newChartType) => {
              setSelectedChartType(newChartType);
            }}
          />
        )}
    </div>
  );
};
export default WidgetMaintenanceDue;
